// extracted by mini-css-extract-plugin
module.exports =  {"icon":"OM-UM"};